import React, { useState } from 'react';
import { Button, Card, Collapse, ListGroup } from 'react-bootstrap';
import { FaCaretUp, FaCaretDown, FaPencilAlt } from 'react-icons/fa';
import { IconButton } from 'rsuite';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import SectionEditModal from '../SectionEditModal';
import { get } from 'lodash';
import CommandEditModal from '../CommandEditModal';
import SimpleText from 'reusable/Text';

const ControlSection = ({
  action,
  layout,
  handleOnDragEnd,
  moveSection,
  moveCommand,
  onSectionEdit,
  onCommandEdit,
  onNameEdit,
}) => {
  const [sectionModal, setSectionModal] = useState({} as any);
  const [commandModal, setCommandModal] = useState({} as any);
  const [expanded, setExpanded] = useState({});

  const toggle = name => {
    setExpanded(prev => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <SectionEditModal
        show={sectionModal.show}
        onHide={() => {
          setSectionModal({});
        }}
        action={sectionModal.action}
        value={sectionModal.value || { visible: true }}
        index={sectionModal.index}
        onSubmit={onSectionEdit}
        sections={get(layout, 'sections', []).map(section => section.name)}
      />
      <CommandEditModal
        show={commandModal.show}
        onHide={() => {
          setCommandModal({});
        }}
        action={commandModal.action}
        value={
          typeof commandModal.value === 'string'
            ? commandModal.value
            : commandModal.value || { visible: true }
        }
        index={commandModal.index}
        section={commandModal.section}
        onSubmit={onCommandEdit}
      />
      <SimpleText
        label="Name *"
        value={layout.name}
        onChange={onNameEdit}
        disabled={action === 'edit'}
      />
      <br />
      {get(layout, 'sections', []).map((section, index) => (
        <Card>
          <Card.Header
            onClick={() => toggle(section.name)}
            className="control-header"
          >
            <div className={section.visible ? '' : 'faded'}>{section.name}</div>
            {section.name !== 'Controls' && (
              <div className="action-group">
                <IconButton
                  icon={<FaCaretUp />}
                  circle
                  onClick={e => {
                    e.stopPropagation();
                    moveSection(index, index - 1);
                  }}
                />
                <IconButton
                  icon={<FaCaretDown />}
                  circle
                  onClick={e => {
                    e.stopPropagation();
                    moveSection(index, index + 1);
                  }}
                />
                <IconButton
                  icon={<FaPencilAlt />}
                  circle
                  onClick={e => {
                    e.stopPropagation();
                    setSectionModal({
                      action: 'edit',
                      index,
                      show: true,
                      value: section,
                    });
                  }}
                />
              </div>
            )}
          </Card.Header>
          <Collapse in={!!expanded[section.name]} unmountOnExit>
            <>
              <Droppable droppableId={`${section.name}:commandsSection`}>
                {droppableProvided => (
                  <Card.Body
                    className="control-body"
                    {...droppableProvided.droppableProps}
                    ref={droppableProvided.innerRef}
                  >
                    {section.values.map((value, commandIdx) => {
                      const key =
                        typeof value === 'string'
                          ? `${value}-${commandIdx}`
                          : `${value.command}`;
                      const title =
                        typeof value === 'string'
                          ? value
                          : `${value.display || value.icon} : ${value.command}`;
                      const visible =
                        typeof value === 'string' ? true : value.visible;

                      return (
                        <Draggable
                          key={key}
                          draggableId={key}
                          index={commandIdx}
                        >
                          {provided => (
                            <ListGroup.Item
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="command-item"
                            >
                              <div
                                className={`command-title ${
                                  visible ? '' : 'faded'
                                }`}
                              >
                                {title}
                              </div>
                              <div className="action-group">
                                <IconButton
                                  icon={<FaCaretUp />}
                                  circle
                                  onClick={e =>
                                    moveCommand(
                                      section.name,
                                      commandIdx,
                                      section.name,
                                      commandIdx - 1,
                                    )
                                  }
                                />
                                <IconButton
                                  icon={<FaCaretDown />}
                                  circle
                                  onClick={e =>
                                    moveCommand(
                                      section.name,
                                      commandIdx,
                                      section.name,
                                      commandIdx + 1,
                                    )
                                  }
                                />
                                <IconButton
                                  icon={<FaPencilAlt />}
                                  circle
                                  onClick={() =>
                                    setCommandModal({
                                      section: section.name,
                                      action: 'edit',
                                      index: commandIdx,
                                      value,
                                      show: true,
                                    })
                                  }
                                />
                              </div>
                            </ListGroup.Item>
                          )}
                        </Draggable>
                      );
                    })}
                    {droppableProvided.placeholder}
                  </Card.Body>
                )}
              </Droppable>
              <Button
                onClick={() =>
                  setCommandModal({
                    section: section.name,
                    action: 'add',
                    index: -1,
                    show: true,
                  })
                }
              >
                Add Command
              </Button>
            </>
          </Collapse>
        </Card>
      ))}
      <Button
        onClick={() =>
          setSectionModal({ action: 'add', index: -1, show: true })
        }
      >
        Add Section
      </Button>
    </DragDropContext>
  );
};

export default ControlSection;
